import { IAuthClient, IExtensionsRegistration, IHttpClient, IHttpClientRequest } from '@msx/platform-services';
import { DefaultHttpClientRequest } from '../App.types';
import { IDataService, IUserProfile, ICopilotConfig } from '../interfaces';
import { appConfig } from '../App.config';
import { ITeachingBubble } from '@fluentui/react/lib/TeachingBubble';
import { IAnnouncement } from '../interfaces/IAnnouncemnet';


export class DataService implements IDataService {
  private httpClient: IHttpClient;
  private authClient: IAuthClient;
  private baseUrl: string;

  public constructor(httpClient: IHttpClient, authClient: IAuthClient) {
    this.httpClient = httpClient;
    this.authClient = authClient;
    this.baseUrl = appConfig.apiConfig.baseUrl;
  }

  public async GetUserProfile(): Promise<IUserProfile> {
    const url = appConfig.isMockData ?
      '/data/userProfile.json' :
      `${this.baseUrl}userSettings`;

    if (appConfig.isMockData) {
      return new Promise((resolve, reject): void => {
        fetch(url)
          .then(response => response.json())
          .then((data): void => {
            resolve(data as IUserProfile);
          })
          .catch((error): void => {
            reject(error);
          });
      });
    }

    return new Promise((resolve, reject): void => {
      const request: IHttpClientRequest = {
        ...DefaultHttpClientRequest,
        method: 'GET',
        url: url
      };
      this.httpClient
        .request<IUserProfile>(request)
        .then((response): void => {
          resolve(response.data);
        })
        .catch((error): void => {
          reject(error);
        });
    });
  }

  public async GetExtensionsRegistration(): Promise<IExtensionsRegistration> {
    // TODO: Actual API endpoint integration 
    const url = `${appConfig.registrationConfig.apiEndpoint}`;

    if (appConfig.isMockData) {
      return new Promise((resolve, reject): void => {
        fetch(url)
          .then(response => response.json())
          .then((data): void => {
            resolve(data as IExtensionsRegistration);
          })
          .catch((error): void => {
            reject(error);
          });
      });
    }

     return new Promise((resolve, reject): void => {
      const request: IHttpClientRequest = {
        ...DefaultHttpClientRequest,
        method: 'GET',
        url: url
      };
      this.httpClient.request<IExtensionsRegistration>(request)
        .then((response): void => {
          resolve(response.data);
        })
        .catch((error): void => {
          reject(error);
        });
    });
  }

  public async GetCopilotConfig(): Promise<ICopilotConfig> {
    const url = `${this.baseUrl}/Copilot/GetCopilotConfig`;

    return new Promise((resolve, reject): void => {
      const request: IHttpClientRequest = {
        ...DefaultHttpClientRequest,
        method: 'GET',
        url: url
      };
      this.httpClient
        .request<ICopilotConfig>(request)
        .then((response): void => {
          resolve(response.data);
        })
        .catch((error): void => {
          reject(error);
        });
    });
  }
  /**
   * DownloadSupplierTemplate function - To download the universal template
   * @param {string} templateType - templateType is required to download the Universal Template
   * @returns {Promise<any>} - Promise 
   */
  public async DownloadSupplierTemplate(templateType: string): Promise<any> {
    const url = `${this.baseUrl}/api/ImportExport/Export/GeneralTemplate/${templateType}`;

    return new Promise((resolve, reject): void => {
      
      const requestType = {
        ...DefaultHttpClientRequest,
        //response type is required here to convert the response into excel format
        responseType: "arraybuffer" as ResponseType,
      };

      const request: any = {
        ...requestType,
        method: "GET",
        url: url,
      };

      this.httpClient
        .request<any>(request)
        .then((response): void => {
          resolve(response.data);
        })
        .catch((error): void => {
          reject(error);
        });
    });
  };

  public async SupplierTemplateVersion(templateType: string) : Promise<any> {
    const url = `${this.baseUrl}/api/Common/TemplateVersion/${templateType}`

    return new Promise((resolve, reject): void => {
      const request: IHttpClientRequest = {
        ...DefaultHttpClientRequest,
        method: 'GET',
        url: url
      };
      this.httpClient
        .request(request)
        .then((response): void => {
          resolve(response.data);
        })
        .catch((error): void => {
          reject(error);
        });
    });
  }
};
